module.exports = {
  sentryEnabled: true,
  coreApi: {
    protocol: "https",
    host: "api-gcp.ct-production.net",
  },
};
